const TOKEN_KEY = 'course-website-token'
const PROFILE_KEY = 'course-website-profile'

const getStorage = () => {
  if (typeof window === 'undefined') {
    return null
  }

  return window.localStorage
}

export const getToken = () => {
  const storage = getStorage()

  return storage ? storage.getItem(TOKEN_KEY) || '' : ''
}

export const setToken = (token) => {
  const storage = getStorage()

  if (!storage) {
    return
  }

  if (token) {
    storage.setItem(TOKEN_KEY, token)
  } else {
    storage.removeItem(TOKEN_KEY)
  }
}

export const getStoredProfile = () => {
  const storage = getStorage()

  if (!storage) {
    return null
  }

  const rawProfile = storage.getItem(PROFILE_KEY)

  if (!rawProfile) {
    return null
  }

  try {
    return JSON.parse(rawProfile)
  } catch (error) {
    storage.removeItem(PROFILE_KEY)
    return null
  }
}

export const setStoredProfile = (profile) => {
  const storage = getStorage()

  if (!storage) {
    return
  }

  if (profile) {
    storage.setItem(PROFILE_KEY, JSON.stringify(profile))
  } else {
    storage.removeItem(PROFILE_KEY)
  }
}

export const clearStoredSession = () => {
  const storage = getStorage()

  if (!storage) {
    return
  }

  storage.removeItem(TOKEN_KEY)
  storage.removeItem(PROFILE_KEY)
}
